module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter-title",
    attrs: {
      "id": "ch-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('strong', [_vm._v("A. Constitutional Exemptions Before "), _c('em', [_vm._v("Smith")])])])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("All the material in this Section was written before the Court’s decision in "), _c('em', [_vm._v("Employment Division v. Smith.")]), _vm._v(" It addresses illustrative cases litigated under the pre-"), _c('em', [_vm._v("Smith")]), _vm._v(" regime. There are two amicus briefs and two short articles addressed to religious audiences.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The law before "), _c('em', [_vm._v("Smith")]), _vm._v(" was much better for churches and believers than the law after "), _c('em', [_vm._v("Smith")]), _vm._v(", but even before "), _c('em', [_vm._v("Smith")]), _vm._v(" these cases were hard to win. Indeed, the religious claimant lost each of the cases in this Section.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-1"
    }
  }, [_c('strong', [_vm._v("The Briefs …")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("In "), _c('em', [_vm._v("Mozert v. Hawkins County Public Schools")]), _vm._v(" (1987), parents sought to exempt their children from using a reader that undermined their religious faith.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In "), _c('em', [_vm._v("Jimmy Swaggart Ministries v. Board of Equalization")]), _vm._v(" (1990), Swaggart sought to exempt the sale of religious books and recordings from the California sales and use tax.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Briefs are not hard to read. For a quick guide to their main peculiarity, see the third-to-last paragraph of the Preface to this volume.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-2"
    }
  }, [_c('strong', [_vm._v("… and the Articles")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('em', [_vm._v("Peyote, Wine, and the First Amendment")]), _vm._v(" is an explanation of the issues in "), _c('em', [_vm._v("Employment Division v. Smith")]), _vm._v(" and why Christians should care about those issues, written before the case was decided, when religious liberty scholars all thought it would be decided under then-existing law.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('em', [_vm._v("Churches Are Living on Borrowed Time")]), _vm._v(" is an interview about the "), _c('em', [_vm._v("Swaggart")]), _vm._v(" case, after it was decided.")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-3"
    }
  }, [_c('strong', [_vm._v("Cross References")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("All the entries in this Section are short. My most substantial scholarly treatment of the exemption issue prior to "), _c('em', [_vm._v("Smith")]), _vm._v(" is in "), _c('em', [_vm._v("A Survey of Religious Liberty in the United States")]), _vm._v(", in Volume 1.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8e2bab3a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/009_Chapter01.vue
// module id = 81
// module chunks = 0